"use client";

import { BlogLink, Content, Header } from "@/components/shared/public/blogs";
import { useTranslations } from "next-intl";
import {
  header,
  section1,
  section2,
  section3,
  section4,
} from "../../../../../../public/images/blogs/floorPlanSingleFamilyHouse";

export default function BlogContent() {
  const t = useTranslations("blogs.floorPlanSingleFamilyHouse");

  return (
    <>
      <Header
        title={t("header.title")}
        text={t("header.text")}
        src={header}
        alt={t("header.imageAlt")}
      />
      <div className="gs--blog-body flex flex-col gap-10 py-16">
        <Content
          imageFit="cover"
          title={t("sections.section1.title")}
          text={t.rich("sections.section1.text", {
            br: () => <br></br>,
            link: (chunks) => (
              <BlogLink href="/blog/baufinanzierung">{chunks}</BlogLink>
            ),
            link2: (chunks) => (
              <BlogLink href="/blog/bemasster-grundriss-fuer-bank">
                {chunks}
              </BlogLink>
            ),
            link3: (chunks) => (
              <BlogLink href="/blog/expose">{chunks}</BlogLink>
            ),
            bold: (chunks) => <strong>{chunks}</strong>,
          })}
          src={section1}
          alt={t("sections.section1.imageAlt")}
          imageLeft={true}
        />
        <Content
          imageFit="cover"
          title={t("sections.section2.title")}
          text={t.rich("sections.section2.text", {
            br: () => <br></br>,
            link: (chunks) => (
              <BlogLink href="/blog/schnitte-und-ansichten">{chunks}</BlogLink>
            ),
            link2: (chunks) => (
              <BlogLink href="/blog/grundriss">{chunks}</BlogLink>
            ),
            link3: (chunks) => (
              <BlogLink href="/blog/expose">{chunks}</BlogLink>
            ),
            bold: (chunks) => <strong>{chunks}</strong>,
          })}
          src={section2}
          alt={t("sections.section2.imageAlt")}
        />
        <Content
          imageFit="cover"
          title={t("sections.section3.title")}
          text={t.rich("sections.section3.text", {
            br: () => <br></br>,
          })}
          src={section3}
          alt={t("sections.section3.imageAlt")}
          imageLeft={true}
        />
        <Content
          imageFit="cover"
          title={t("sections.section4.title")}
          text={t.rich("sections.section4.text", {
            br: () => <br></br>,
            link: (chunks) => (
              <BlogLink href="/blog/schnitte-und-ansichten">{chunks}</BlogLink>
            ),
            link2: (chunks) => (
              <BlogLink href="/blog/expose">{chunks}</BlogLink>
            ),
            bold: (chunks) => <strong>{chunks}</strong>,
          })}
          src={section4}
          alt={t("sections.section4.imageAlt")}
          disclaimer="default"
        />
      </div>
    </>
  );
}
